module.exports = __webpack_public_path__ + "static/loopdarkmode-8e6518f54c27f226973d2d5a29a149ea.png";